import { connect } from 'react-redux';
import DaEditorWrapper from './DaEditorWrapper';
import { mentionSearchChange } from './AsyncHandlers/Mentions/actionCreators';
import { findPastedDeviation } from './AsyncHandlers/DeviationPaste/actionCreators';
import { fetchFreshDeviations } from './AsyncHandlers/FetchFresh/actionCreators';
import { markEditorFocused, markEditorInactive, uploadDraggedFile } from './redux/actionCreators';
import { getFlags } from '../redux/flags/selectors';
import { getCurrentUser, getTheme } from '../publicSession/selectors';
const mapStateToProps = (state, props)=>({
        featureFlags: getFlags(state),
        currentUser: getCurrentUser(state),
        currentTheme: getTheme(state)
    });
const mapDispatchToProps = {
    mentionSearchChange,
    findPastedDeviation,
    editorFocused: markEditorFocused,
    editorBlurred: markEditorInactive,
    uploadFile: uploadDraggedFile,
    fetchFreshDeviations: fetchFreshDeviations
};
export default connect(mapStateToProps, mapDispatchToProps)(DaEditorWrapper);
